import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { METER_CORE_DENSITY_OPTIONS } from 'constants/projects';

import acToHectares from 'util/units';

import { useCarbonPlanConfigQuery } from './Form/queries';
import { useSamplePlanFormContext } from './samplePlanFormContextV2';
import { getSamplePlanFormValues } from './utils';

export const useProjectsTranslations = () => {
  const { t } = useTranslation();
  return {
    cancel: t('cancel'),
    generateSamplingPlan: t('generateSamplingPlan'),
    chooseRegistry: t('chooseRegistry'),
    registry: t('registry'),
    meterCoreSampleDetails: t('meterCoreSampleDetails'),
    density: t('density'),
    per: t('per'),
    acres: t('acres'),
    splitCore: t('splitCore'),
    lab: t('lab'),
    min1PerField: t('min1PerField'),
    splits: t('splits'),
    analytics: t('analytics'),
    coldStorage: t('coldStorage'),
    carbon30cmSampleDetails: t('carbon30cmSampleDetails'),
    bulkDensity30cmSampleDetails: t('bulkDensity30cmSampleDetails'),
    equivalentSoilMass: t('equivalentSoilMass'),
    texturePhSampleDetails: t('texturePhSampleDetails'),
    soilHealthSampleDetails: t('soilHealthSampleDetails'),
    photos: t('photos'),
    sampleLocation: t('sampleLocation'),
    photosRequiredSampleLocation: t('photosRequiredSampleLocation'),
    fieldLevelPhotos: t('fieldLevelPhotos'),
    photosRequiredFieldLevel: t('photosRequiredFieldLevel'),
    exclusionLayers: t('exclusionLayers'),
    exclusionLayersMultiSelect: t('exclusionLayersMultiSelect'),
    chooseYourExclusionLayers: t('chooseYourExclusionLayers'),
    stratification: t('stratification'),
    stratify: t('stratify'),
    complaintRegistriesQuestion: t('complaintRegistriesQuestion'),
    landDetailsQuestion: t('landDetailsQuestion'),
    landType: t('landType'),
    depthQuantifyQuestion: t('depthQuantifyQuestion'),
    depth: t('depth'),
    addTexturePhMsg: t('addTexturePhMsg'),
    reduceBDSamples: t('reduceBDSamples'),
    onePerFieldSocBdMsg: t('onePerFieldSocBdMsg'),
    treeAndShrubCover: t('treeAndShrubCover'),
    steepSlope: t('steepSlope'),
    wetlands: t('wetlands'),
    wetAggregateStabilityDetails: t('wetAggregateStabilityDetails'),
    carbonPlanConfirmTitle: t('carbonPlanConfirmTitle'),
    carbonPlanConfirmBody: t('carbonPlanConfirmBody'),
    confirm: t('confirm'),
    textureDensity: t('textureDensity'),
    createSamplingPlan: t('createSamplingPlan'),
    success: t('success'),
    allProjects: t('allProjects'),
    project: t('project'),
    error: t('error'),
    ensureOneSamplePerThousandMsg: t('ensureOneSamplePerThousandMsg'),
    minOnePerFieldMsg: t('minOnePerFieldMsg'),
    doNotSplit: t('doNotSplit'),
    warning: t('warning'),
  };
};

export const getDensityOptions = () => {
  const { i18n } = useTranslation();
  const translations = useProjectsTranslations();

  return METER_CORE_DENSITY_OPTIONS.map((value) => ({
    value: String(value),
    label: `1 ${translations.per} ${acToHectares(Number(value), i18n.language)} ${translations.acres}`,
  }));
};

export const useUpdateFormsFromConfig = () => {
  const { samplePlanConfig } = useCarbonPlanConfigQuery();
  const samplePlanForm = useSamplePlanFormContext();

  useEffect(() => {
    if (samplePlanConfig) {
      samplePlanForm.setValues(getSamplePlanFormValues(samplePlanConfig));
      samplePlanForm.getInputProps('exclusion_layers').onChange(samplePlanConfig.exclusion_layers);
    }
  }, [samplePlanConfig]);
};
